<app-page>
    <app-user [userId]="userId" *ngIf="userId"></app-user>
    <app-user [userEmail]="userEmail" *ngIf="userEmail"></app-user>
</app-page>
